import { render, staticRenderFns } from "./userlogin.vue?vue&type=template&id=2fcd2d3a&scoped=true"
import script from "./userlogin.vue?vue&type=script&lang=js"
export * from "./userlogin.vue?vue&type=script&lang=js"
import style0 from "./userlogin.vue?vue&type=style&index=0&id=2fcd2d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcd2d3a",
  null
  
)

export default component.exports